import { t } from "i18next";
import React, { useEffect, useState } from "react";
import { CustomModal } from "../CustomModal/CustomModal";
import {
  DocsDueContractsByContractorSection,
  getVisibleContractors,
} from "./DocsDueContractsByContractorSection";
import { getSettingService } from "../../services/Settings";
import { Spinner } from "reactstrap";
import { EmptyStateOne } from "../Empty/EmptyStateOne";

export const DocumentDueContractsModal = ({
  showDocsByResource,
  contracts,
  showModal,
  setShowModal,
}) => {

  const getContractorGroup = (contract = {}) => {
    if (contract?.contract_maincontractor_status !== undefined) {
      return "main";
    }

    return "contractor";
  };

  const filterDocumentsByResource = (documents = []) => {
    return documents.filter((document) => {
      const type = document?.resource_type;
      if (type === "C") {
        return true;
      }
      if (showDocsByResource) {
        return type === showDocsByResource;
      }
      return true;
    });
  };

  const contractsList = Array.isArray(contracts) ? contracts : [];

  const groupedByContractor = contractsList.reduce(
    (acc, contract) => {
      const documentsDue = filterDocumentsByResource(
        contract?.contract_due_documents || []
      );

      const groupType = getContractorGroup(contract);
      const contractorId = contract?.contract_contractor_id || "without-id";
      const contractorKey = `${groupType}-${contractorId}`;

      if (!acc[groupType][contractorKey]) {
        acc[groupType][contractorKey] = {
          contractorName: contract?.contractor_name || "-",
          contracts: [],
        };
      }

      acc[groupType][contractorKey].contracts.push({
        id:
          contract?.idCONTRATO || `${contractorKey}-${contract?.contract_code}`,
        contractCode: contract?.contract_code || "-",
        contractDescription: contract?.contract_description || "-",
        documentsDue,
      });

      return acc;
    },
    { contractor: {}, main: {} }
  );

  const hasVisibleSections =
    getVisibleContractors(groupedByContractor.contractor).length > 0 ||
    getVisibleContractors(groupedByContractor.main).length > 0;

  const [loading, setLoading] = useState(true);
  const [contractsForResourceAptitude, setContractsForResourceAptitude] =
    useState(false);

  const hasUnassignedContract = contractsList.some(
    (contract) => contract?.is_assigned_to_resource === false
  );

  const getAptitudeMessage = () => {
    if (!contractsForResourceAptitude) {
      return t("CONTRACTS_NOT_CONSIDERED_FOR_ENTRY");
    }

    if (hasUnassignedContract) {
      if (showDocsByResource === "V") {
        return t("CONTRACTS_CONT_STATUS_CONSIDERED_ENTRY_VEH");
      }
      if (showDocsByResource === "E") {
        return t("CONTRACTS_CONT_STATUS_CONSIDERED_ENTRY_EMP");
      }
    }

    return t("CONTRACTS_CONSIDERED_FOR_ENTRY");
  };

  useEffect(() => {
    const fetchSetting = async () => {
      const response = await getSettingService(
        "?keyword=contracts_for_resource_aptitude"
      );
      if (response && response.ok && response.data.response?.length > 0) {
        setContractsForResourceAptitude(
          response.data.response[0].setting_value === "1"
        );
        setLoading(false);
      }
    };
    fetchSetting();
  }, []);

  return (
    <CustomModal
      showModal={showModal}
      setShowModal={setShowModal}
      centered
      title={t("DUE_DOC_CONTRACTS")}
    >
      <div className="row row-cols-1 gap-2">
        {loading && (
          <div className="d-flex align-items-center">
            <Spinner className="new-orange-color" size="sm" />
          </div>
        )}

        {!loading && hasVisibleSections && (
          <span
            className={`fw-bold m-0 ${
              contractsForResourceAptitude
                ? "new-orange-color"
                : "gray-900-color"
            }`}
          >
            {getAptitudeMessage()}
          </span>
        )}

        {hasVisibleSections ? (
          <>
            <DocsDueContractsByContractorSection
              title={t("CONT")}
              contractorsMap={groupedByContractor.contractor}
              contractorTypeLabel={t("CONT")}
            />

            <DocsDueContractsByContractorSection
              title={t("CONT_MAIN")}
              contractorsMap={groupedByContractor.main}
              contractorTypeLabel={t("CONT")}
            />
          </>
        ) : (
          <EmptyStateOne message={t("NO_DATA")} />
        )}
      </div>
    </CustomModal>
  );
};
